import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Paddle, initializePaddle } from '@paddle/paddle-js';
import expiredTrial from '../../assets/images/dashboard/dashboardElements/expiredTrial.png';
import SubscriptionCard from '../../components/cards/subscription-card';
import { useOrganizationSettingsStore } from '../../store/organizationSettingsStore';
import { DiggerPlanEnum } from '../../components/enums/DiggerPlanEnum';
import digtectiveLogoWhite from '../../assets/images/logos/digtective-logo-white.png';

const ExpiredTrialPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { productId } = useOrganizationSettingsStore((state) => state.organizationSettings);
  const [paddle, setPaddle] = useState<Paddle>();

  useEffect(() => {
    initializePaddle({
      environment: 'sandbox',
      token: 'live_230f7971152d4c15b41777c4b7f',
    }).then(
      (paddleInstance: Paddle | undefined) => {
        if (paddleInstance) {
          setPaddle(paddleInstance);
        }
      },
    );
  }, []);

  const openCheckout = (priceId: string) => {
    paddle?.Checkout.open({
      items: [{ priceId, quantity: 1 }],
    });
  };

  return (
    <div
      className="fixed inset-0 z-[9999999999] flex flex-col items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `url(${expiredTrial})`,
      }}
    >
      <div className="align-center flex">
        <button
          onClick={() => navigate('../auth')}
          className="absolute left-[190px] top-[40px] flex h-[27px] w-[67px] items-center justify-center rounded-[4px] border
           text-[10px] text-white"
        >
          {t('back')}
        </button>
        <img src={digtectiveLogoWhite} className="absolute right-[190px] top-[-7px] mt-12 h-[40px] w-auto" />
        <p className="absolute left-[190px] top-[35px] mt-12 text-[30px]  leading-[48px] text-white">
          {t('chooseYourPlan')}
        </p>
        <p className="absolute left-[190px] top-[85px] mt-12 text-[16px] leading-[24px] text-[#F5F5F5]">
          {t('reSubscribe')}
        </p>
      </div>

      <div
        className="items-cesaoasaolsaolnter mt-[160px] flex justify-center gap-5 rounded-[20px] bg-[#FFFFFF] bg-opacity-60
        px-9 py-4"
      >
        <SubscriptionCard
          title="standardPlan"
          description="bestForEmergingBusinesses"
          price={500}
          loginVersion
          buttonText="chooseStandard"
          onClick={() => openCheckout('pri_01jh86yey1fgsr2e1xxknv315p')}
          color="yellow"
          isActive={productId === DiggerPlanEnum.standard}
          priceId="pri_01jh86yey1fgsr2e1xxknv315p"
          featureInclusionText="everythingIncludedInLitePlus"
          features={[
            'allSourceConnections',
            'basicReportsPlus',
            'limitedAdSpend',
            'limitedConversions',
          ]}
        />
        <SubscriptionCard
          title="proPlan"
          price={1500}
          description="bestForGrowingBusinesses"
          buttonText="chooseProfessional"
          onClick={() => openCheckout('pri_01jh86v9pjjw7v70mrm0pskgd1')}
          color="green"
          loginVersion
          isActive={productId === DiggerPlanEnum.pro}
          priceId="pri_01jh86v9pjjw7v70mrm0pskgd1"
          featureInclusionText="everythingIncludedInStandardPlus"
          features={[
            'advancedReporting',
            'connectToOneCRM',
            'offlineConversionReporting',
            'limitedAdSpend',
            'unlimitedConversions',
            'unlimitedActiveAds',
          ]}
        />
        <SubscriptionCard
          title="enterPrisePlan"
          price={5000}
          description="bestForLargeOrganizations"
          buttonText="chooseEnterPrise"
          onClick={() => openCheckout('pri_01jh86r58epfyntb3956b0cf5r')}
          color="primary"
          loginVersion
          isActive={productId === DiggerPlanEnum.enterprise}
          featureInclusionText="everythingIncludedInProPlus"
          features={[
            'unlimitedLeads',
            'unlimitedTraffic',
            'connectToMultipleCRM',
            'unlimitedDomains',
            'quarterlyReviews',
            'dedicatedSuccessManager',
            'supportEmailPhone',
          ]}

        />
      </div>
    </div>
  );
};

export default ExpiredTrialPage;
